export const isAuthenticated = () => localStorage.getItem('token') !== null;
export const authenticate = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};
export const logout = () => localStorage.clear();
export const getUser = () => JSON.parse(localStorage.getItem('user'));
export const getToken = () => localStorage.getItem('token');


// WEBPACK FOOTER //
// ./src/utils/auth.js